import { render, staticRenderFns } from "./CreateEncuesta.vue?vue&type=template&id=83a03bce"
import script from "./CreateEncuesta.vue?vue&type=script&lang=js"
export * from "./CreateEncuesta.vue?vue&type=script&lang=js"
import style0 from "./CreateEncuesta.vue?vue&type=style&index=0&id=83a03bce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports